// priceutil.js

export const getEffectivePrice = (
  sku,
) => {
  if (!sku) return 0;

  const now = Math.floor(
    Date.now() / 1000,
  );

  const hasPromo =
    sku?.promo &&
    sku?.promo > 0;

  const isAlwaysPromo =
    sku?.promoStartDate ==
      null &&
    sku?.promoEndDate == null;

  const isInRange =
    sku?.promoStartDate &&
    sku?.promoEndDate &&
    now >= sku.promoStartDate &&
    now <= sku.promoEndDate;

  const promoActive =
    hasPromo &&
    (isAlwaysPromo ||
      isInRange);

  return promoActive
    ? sku.promo
    : sku.price;
};

export const isSkuInStock = (
  sku,
) => {
  return sku?.stock > 0;
};
// export const getEffectivePrice = (sku) => {
//   const now = Math.floor(Date.now() / 1000);

//   if (!sku) return 0;

//   const hasPromo = sku.promo && sku.promo > 0;

//   const isAlwaysPromo =
//     sku.promoStartDate == null && sku.promoEndDate == null;

//   const isInRange =
//     sku.promoStartDate &&
//     sku.promoEndDate &&
//     now >= sku.promoStartDate &&
//     now <= sku.promoEndDate;

//   const promoActive = hasPromo && (isAlwaysPromo || isInRange);

//   return promoActive ? sku.promo : sku.price;
// };

// export const isSkuInStock = (sku) => sku?.stock > 0;

